// Hook to get sidebar theme configuration
import { useAppStore } from '../stores';

export function useSidebarTheme() {
  const { themeConfig } = useAppStore();
  return themeConfig.sidebar;
}
